// pantalla de comunicacion de HBO Max (ruta /activacionhbo y opcion de Mi Cuenta)

// Ruta fija. Vive aqui (sin imports) para que el login/perfil la usen sin arrastrar RouteConstants
export const HBO_COMMUNICATION_PATH = '/activacionhbo';

export const HBO_COMMUNICATION_ORIGIN = {
  MENU: 'menu configuraciones',
  DIRECT_LINK: 'enlace directo',
};

// Limites acordados (DECISIONS.md P5/P6). Superarlos envia a Home sin mostrar error.
export const HBO_COMMUNICATION_STATUS_TIMEOUT_MS = 8000;
export const HBO_COMMUNICATION_HYDRATION_TIMEOUT_MS = 15000;
// Supuesto no confirmado: vigencia de la intencion de volver tras el login
export const HBO_COMMUNICATION_INTENT_TTL_MS = 30 * 60 * 1000;
//tras el login/seleccion de perfil, otros flujos pueden mandar a Home despues
// de reanudar. La intencion se reafirma durante esta ventana (medida desde la primera
// reanudacion) y luego se descarta; Regresar o la guarda a Home la limpian antes.
export const HBO_COMMUNICATION_INTENT_SETTLE_MS = 10 * 1000;

const KEY_PREFIX = 'activahbomax_pantallainfo_';

// Forma { key } compatible con translationMapper
export const HBO_COMMUNICATION_TEXT_KEYS = {
  TITLE_1: { key: `${KEY_PREFIX}texto_titulo1` },
  TITLE_2: { key: `${KEY_PREFIX}texto_titulo2` },
  PARAGRAPH_1: { key: `${KEY_PREFIX}texto_parrafo1` },
  PARAGRAPH_2: { key: `${KEY_PREFIX}texto_parrafo2` },
  PARAGRAPH_3: { key: `${KEY_PREFIX}texto_parrafo3` },
  ACTIVATE_LABEL: { key: `${KEY_PREFIX}boton_texto_activalo` },
};


export const HBO_COMMUNICATION_ASSET_KEYS = {
  EXIT_ICON: `${KEY_PREFIX}icono_salir`,
  HBO_LOGO: `${KEY_PREFIX}logohbomax`,
  POSTER: `${KEY_PREFIX}postercontenido_hbomax`,
  POSTER_OVERLAY: `${KEY_PREFIX}postercontenido_Overlay`,
  CLARO_VIDEO_LOGO: `${KEY_PREFIX}logo_clarovideo`,
  CLARO_TV_LOGO: `${KEY_PREFIX}logo_clarotv`,
  BACKGROUND: `${KEY_PREFIX}background_hbomax`,
};

